import { ILinkInfo } from '@src/api/types'
import axios from 'axios'

const apiCloud = axios.create({
    baseURL: 'https://cloud-api.yandex.net/v1/disk/public',
})

export const imageInfo = (public_key: string) => {
    return apiCloud.get<ILinkInfo>('/resources', { params: { public_key, limit: 1000 } })
}

export const downloadLink = (public_key: string, path: string) => {
    return apiCloud.get<{ href: string }>('/resources/download', {
        params: {
            path,
            public_key,
        },
    })
}
